<template>
  <section class="custom-wrapper">
    <div
      class="table-responsive"
      :class="{ 'disabled': $loading.isLoading('getOwnerTestdrives') }"
    >
      <!-- Drives Listing -->
      <div
        ref="listingWrapper"
        class="listingWrapper"
      >
        <dt-table
          v-model="testdrives"
          class="table table-bordered table-striped"
          :isSingleRowDetail="false"
          sortOn="id"
          sortDir="asc"
          :columns="tableColumnsName"
        >
          <template
            slot="tbody"
            slot-scope="props"
          >
            <td class="custom-column-60">
              <a
                href="#"
                @click="showDrive(props.row)"
              >view</a>
            </td>
            <td class="custom-column-60">{{ props.row.testdrive }}</td>
            <td>{{ props.row.testdriveType }}</td>
            <th scope="row">{{ props.row.ronumber }}</th>
            <td>{{ formatDate(props.row.createdOn) }}</td>
            <td>{{ props.row.statusName }}</td>
            <td>{{ props.row.vin }}</td>
            <td>{{ props.row.year }}</td>
            <td>{{ props.row.make }}</td>
            <td>{{ props.row.model }}</td>
            <td>{{ props.row.insuranceName }}</td>
          </template>
          <template slot="empty"> Nothing found! </template>
        </dt-table>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import DtTable from '@/components/utilities/table/dt-table'
export default {
  name: 'contact-drives',
  components: {
    DtTable
  },
  props: {
    contact: Number
  },
  data() {
    return {
      actionDrive: null
    }
  },
  mounted() {
    if (this.contact !== undefined && this.contact !== null) {
      this.getOwnerTestdrives(this.contact)
    }
  },
  computed: {
    ...mapGetters('testdrives', ['testdrive', 'testdrives']),
    ...mapGetters('auth', ['profile']),
    tableColumnsName() {
      return [
        {
          field: 'testdrive',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        },
        {
          field: 'testdrive',
          label: '#',
          sortable: true,
          class: 'custom-column-60'
        },
        {
          field: 'testdriveType',
          label: 'Type',
          sortable: true,
          class: 'custom-column-100 text-center'
        },
        {
          field: 'ronumber',
          label: 'RO #',
          sortable: true,
          class: 'custom-column-100 text-center'
        },
        {
          field: 'createdOn',
          label: 'Date',
          sortable: true
        },
        {
          field: 'statusName',
          label: 'Status',
          sortable: true
        },
        {
          field: 'vin',
          label: 'VIN',
          sortable: true
        },
        {
          field: 'year',
          label: 'Year',
          sortable: true
        },
        {
          field: 'make',
          label: 'Make',
          sortable: true
        },
        {
          field: 'model',
          label: 'Model',
          sortable: true
        },
        {
          field: 'insuranceName',
          label: 'Insurance',
          sortable: true
        }
      ]
    }
  },
  methods: {
    ...mapActions('testdrives', ['getTestdrive', 'getOwnerTestdrives']),
    formatDate(date, type = '') {
      let _date = null
      if (date !== undefined && date !== null) {
        if (type === 'datetime') {
          _date = moment.utc(date).format('MM/DD/YYYY hh:mm a')
        } else {
          _date = moment.utc(date).format('MM/DD/YYYY')
        }
      }
      return _date
    },
    showDrive(data) {
      console.log('Show Test Drive', data)
    }
  }
}
</script>
<style lang='scss' scoped >
.table-responsive.disabled {
  position: relative;
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 10;
    background-color: rgba(255, 255, 255, 0.5);
  }
}
.selectRecord {
  outline: 1px solid blue;
}
.listingWrapper {
  overflow-y: auto;
  max-height: 380px;
}
.custom-wrapper {
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/listings/contact-drives.vue